import React, {useEffect, useState} from 'react';
import ProgressGraph from "./progress-graph";
import ProcessContractModel from "../models/process-contract";

function ContractStatusGraph({
                                 contract,
                                 currentBlock
                             }: { contract: ProcessContractModel, currentBlock: number }): React.ReactElement {

    const [percentage, setPercentage] = useState(0);

    useEffect(() => {
        if (contract) {
            let total: number = currentBlock - parseFloat(contract.startBlock);
            let scanned: number = parseFloat(contract.lastBlockSaved) - parseFloat(contract.startBlock);
            setPercentage((scanned * 100) / total);
        }
    }, [contract, currentBlock]);

    return (
        <div className="w-100 ps-3 pe-3 pt-3 pb-5 mb-2 rounded" style={{backgroundColor: "#f0f8ff"}}>

            <div className="mb-2">
                <span className="form-label"><strong>Contract:</strong></span>
                <span className="form-label ms-2">{contract.hash}</span>
                <span className="form-label ms-2 "><strong>{"( Appx. " + percentage.toFixed(0) + "% complete)"}</strong></span>
            </div>
            <div className="mb-2">
                <span className="form-label"><strong>Last block saved:</strong></span>
                <span className="form-label ms-2">{parseFloat(contract.lastBlockSaved)?.toLocaleString()}</span>
            </div>
            <div className="w-100">
                <span
                    className="float-start normal-text-italic">{(parseFloat(contract.startBlock ? contract.startBlock : "0"))?.toLocaleString()}</span>
                <span className="float-end normal-text-italic">{currentBlock?.toLocaleString()}</span>
            </div>
            <ProgressGraph percentage={percentage}></ProgressGraph>
            <div style={{width: "100%", position: "relative"}}>
                <div className="normal-text-italic form-label fw-bold" style={{
                    right: (100 - percentage) + "%",
                    position: "absolute",
                    fontSize: "10px",
                }}>
                    {(parseFloat(contract.lastBlockSaved ? contract.lastBlockSaved : "0"))?.toLocaleString()}
                </div>
            </div>
        </div>
    );
}

export default ContractStatusGraph;

